module.exports = __webpack_public_path__ + "img/library_sound.274f3ad0.svg";